import React from 'react';
import * as Icon from 'react-feather';

import PermissionCode from '@modules/roles/contantsPermissions';
import { IRouter } from '@routers/interface';

export const routerMemberAndPartnerTabs: IRouter = {
  path: '/member-and-partner/',
  loader: React.lazy(() => import('./index')),
  exact: true,
  menu: {
    icon: <Icon.Users />,
  },
  generateMenu(id) {
    return !Boolean(id);
  },
  name: 'memberAndPartner.name', //translate here for breadcrumb and sidebar
  // permissionCode: [PermissionCode.EXECUTIVE_COMMITTEES_SEARCH],
};
